<template>
  <div class="assistant">
    <div class="assistant-container">
      <div class="assistant-heading">
        <div class="assistant-logo">pubby</div>
        <img src="/images/assistant2.svg" class="assistant-img" />
        <div class="assistant-name">Assistant</div>
      </div>

      <template v-if="assignment.is_kindle">
        <div class="assistant-about">
          Unfortunately, books that require Kindle Unlimited cannot be used with
          Pubby Assistant.
        </div>
      </template>
      <template v-else-if="!review && !assignment.assistant_review_id">
        <div class="assistant-about">
          Short on time? Have one of our assistants suggest a written review to
          you.
        </div>
        <div class="assistant-must-buy" v-if="assignment.is_verified">
          You must still purchase this book on Amazon for this assignment.
          Please purchase the book
          <span style="text-decoration: underline">before</span> sending it to
          an assistant.
        </div>
        <div class="assistant-options">
          <span class="learn-more" @click="toggleMore">Learn More</span>
        </div>
        <div v-if="showMore" class="assistant-more">
          <ul class="upgrade-more-list">
            <li class="upgrade-more-item">
              It typically takes 1-2 days for our assistant to respond with a
              suggested review. If they take longer, your due date will be
              extended for you.
            </li>
            <li class="upgrade-more-item">
              Your suggested review will be shown here when it's ready. At that
              time, you can post it on Amazon and turn in this review.
            </li>
            <li class="upgrade-more-item">
              Each suggested review is unique and written on your behalf. If you
              decide to use it, you are endorsing its perspective as your own.
            </li>
          </ul>
        </div>
        <div class="assistant-buy">
          <div class="buy-option">
            <div
              class="snaps-button"
              :class="{ disabled: isPayNowOpen }"
              @click="requestReview"
            >
              Send to Assistant
            </div>
            <div v-if="!user.assistant_uses" class="snaps-details">
              <span class="snaps-number">Costs 250 snaps</span> or
              <span class="pack-price" @click="clickPayNow"
                >Purchase 10 uses</span
              >
              <!-- <br />Subtracted from your reward when turned in -->
            </div>
            <div v-else class="snaps-details">
              <span class="pack-uses">{{ user.assistant_uses }}</span
              >&nbsp; uses remaining
            </div>
          </div>
          <div class="promote-option-pay" v-if="isPayNowOpen && paymentMethod">
            <div class="payment-line">
              Your
              {{ paymentMethod.card_brand }} card ending in
              <span style="font-weight: 600">{{
                paymentMethod.card_last_four
              }}</span>
              will be charged <span style="font-weight: 600">$19.99</span>.
              <p style="padding-top: 12px; padding-bottom: 0; margin-bottom: 0">
                Your 10 uses never expire and do not cost snaps when used.
              </p>
            </div>
            <div
              @click="confirmPayNow"
              class="payment-button payment-button-later"
            >
              Confirm Payment
            </div>
            <!-- <div @click="cancelPayNow" class="payment-button payment-button-cancel">Cancel</div> -->
            <div class="clearfix"></div>
          </div>
          <!-- <div class="payment-button">Get Access</div>
        <div class="payment-details">
          <span class="special-price">Special Introductory Price (Ending Soon)</span>
          <br />$39.99 for 6 months of unlimited access
        </div>
          <div class="clearfix"></div>-->
        </div>
      </template>
      <template v-else-if="review && review.status === 'Open'">
        <div class="assistant-about">
          We'll have your assistant suggest a written review soon. Thank you!
        </div>
        <div class="assistant-more assistant-more-end">
          <ul class="upgrade-more-list">
            <li class="upgrade-more-item">
              It typically takes 1-3 days for your assistant to respond with a
              suggested review. If they take longer, your due date will be
              extended for you.
            </li>
            <li class="upgrade-more-item">
              Your suggested review will be shown here when it's ready. At that
              time, you can post it on Amazon and turn in this review for
              your snaps.
            </li>
          </ul>
        </div>
      </template>
      <template v-else-if="review && review.status === 'Suggested'">
        <div class="assistant-about">
          Your assistant has suggested a review to you!
        </div>

        <div class="assistant-suggested-review">
          <div class="assistant-suggested-review-summary">
            <img
              class="assistant-suggested-review-summary-stars"
              src="/images/stars-5.svg"
            />
            <div
              class="assistant-suggested-review-summary-text"
              v-html="review.summary"
            ></div>
          </div>
          <div
            class="assistant-suggested-review-content"
            v-html="review.content"
          ></div>
        </div>

        <div class="assistant-must-buy" v-if="assignment.is_verified">
          You must still purchase this book on Amazon for this review.
          Please purchase the book
          <span style="text-decoration: underline">before</span> posting the
          review on Amazon.
        </div>

        <div class="assistant-more assistant-more-end">
          <ul class="upgrade-more-list">
            <li class="upgrade-more-item">
              This suggested review is unique and written on your behalf. If you
              decide to use it, you are endorsing its perspective as your own.
            </li>
            <li class="upgrade-more-item">
              You can post this review on Amazon as-is or edited however you
              wish. Once you've posted it, you can click 'Post your review on
              Amazon' under Your Todos to turn in this assignment.
            </li>
          </ul>
        </div>
      </template>
      <template v-else-if="review && review.status === 'Completed'">
        <div class="assistant-about">
          You completed this assignment with help from your assistant. Thank
          you!
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Back from "../../../modules/Back";
import { mapState } from "vuex";

export default {
  name: "Assistant",
  props: ["assignment"],
  data: function() {
    return {
      showMore: false,
      review: null,
      paymentMethod: null,
      isPayNowOpen: false,
    };
  },
  computed: {
    ...mapState({
      user: "user",
    }),
  },
  methods: {
    toggleMore() {
      this.showMore = !this.showMore;
    },
    async requestReview() {
      // console.log("requestReview request", this.assignment);
      const response = await Back.requestAssistantReview(this.assignment);

      if (!response) {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000,
          }
        );
        return;
      }

      this.$toasted.show("Great! We've sent this to your assistant!", {
        icon: "check_circle",
        position: "bottom-center",
        duration: 3000,
      });

      this.review = response;

      // console.log("requestReview response", response);
    },
    async clickPayNow() {
      // console.log("clickPageNow");
      this.isPayNowOpen = true;

      if (!this.paymentMethod) {
        this.getUserPaymentMethod();
      }
    },
    async confirmPayNow() {
      const response = await Back.userPlaceOrder("assistant-10-uses-sku-1");

      // console.log("paid response", response);

      if (!response) {
        return this.$toasted.show(
          "Oops! Something went wrong. Please try again later or contact our support team.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
      }

      this.$toasted.show(
        "Great! You now have 10 uses of Pubby Assistant in your account!",
        {
          icon: "check_circle",
          position: "bottom-center",
          duration: 3000,
        }
      );
      this.user.assistant_uses = 10;
      this.isPayNowOpen = false;
    },
    async getUserPaymentMethod() {
      const response = await Back.userPaymentMethod();

      if (!response) {
        this.$toasted.show(
          "Your payment method could not be found. Please contact our support team or try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000,
          }
        );
      }

      this.paymentMethod = response;

      // console.log("getUserPaymentMethod", response);
    },
  },
  async mounted() {
    // console.log("assistant mounted", this.assignment);

    if (this.assignment.assistant_review_id) {
      this.review = await Back.assistantReview(
        this.assignment.assistant_review_id
      );
      // console.log("review mounted", this.review);
    }
  },
};
</script>

<style lang="scss">
.assistant-container {
  border: 1px solid #e3e3e3;
  padding: 12px 0 0 0;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}

.assistant-heading {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 8px;

  .assistant-logo {
    padding-top: 0px;
    font-size: 17pt;
    font-weight: 700;
    padding-right: 1px;

    letter-spacing: -1px;
    color: #ef5350;
  }
  .assistant-name {
    padding: 0px 0 0 2px;
    font-size: 17pt;
    color: lighten(#af4448, 10%);
    font-weight: 600;
  }
  .assistant-img {
    height: 30px;
    margin: 3px 0 0 1px;
  }
}

.assistant-options {
  padding: 0px 29px 6px 23px;
  font-size: 13.5pt;
  line-height: 1.35em;
  font-weight: 600;
}

.payment-button {
  float: left;
  margin-right: 8px;
  font-size: 13pt;
  font-weight: 600;
  background: darken($color-blue, 4%);
  background: linear-gradient(
    0deg,
    $color-blue 0%,
    lighten($color-blue, 13%) 100%
  );
  border-radius: 4px;
  border: 2px solid darken($color-blue, 4%);
  border-bottom: 2px solid darken($color-blue, 7%);
  color: #fff;
  padding: 6px 18px;
  padding-top: 5px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  text-shadow: 2px 2px 1px rgba(17, 17, 17, 0.25);
  cursor: pointer;
}
.payment-button:hover {
  background: linear-gradient(
    0deg,
    darken($color-blue, 8%) 0%,
    lighten($color-blue, 5%) 100%
  );
}

.payment-button.disabled {
  float: left;
  margin-right: 8px;
  font-size: 13pt;
  font-weight: 600;
  background: darken($color-blue, 4%);
  background: linear-gradient(
    0deg,
    $color-blue 0%,
    lighten($color-blue, 13%) 100%
  );
  border-radius: 4px;
  border: 2px solid darken($color-blue, 4%);
  border-bottom: 2px solid darken($color-blue, 7%);
  color: #fff;
  padding: 6px 18px;
  padding-top: 5px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  text-shadow: 2px 2px 1px rgba(17, 17, 17, 0.25);
  cursor: pointer;
}
.snaps-button:hover {
  background: linear-gradient(
    0deg,
    darken($color-blue, 8%) 0%,
    lighten($color-blue, 5%) 100%
  );
}

.payment-details {
  margin-left: 6px;
  margin-top: -2px;
  line-height: 1.3em;
  font-size: 12.5pt;
}

.snaps-button {
  width: 154px;
  min-width: 154px;
  height: 41px;
  margin-right: 8px;
  font-size: 13pt;
  font-weight: 600;
  background: darken($color-blue, 4%);
  background: linear-gradient(
    0deg,
    $color-blue 0%,
    lighten($color-blue, 13%) 100%
  );
  border-radius: 4px;
  border: 2px solid darken($color-blue, 4%);
  border-bottom: 2px solid darken($color-blue, 7%);
  color: #fff;
  padding: 6px 0px;
  padding-top: 5px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  text-shadow: 2px 2px 1px rgba(17, 17, 17, 0.25);
  text-align: center;
  cursor: pointer;
}
.snaps-button.disabled {
  text-shadow: none;
  border: 2px solid #bbb;
  background: #bbb;
}

.snaps-details {
  margin-left: 6px;
  margin-top: 5px;
  line-height: 1.3em;
  font-size: 12.5pt;
  font-weight: 500;
  color: #666;
}
.snaps-number {
  color: $color-snaps;
  font-weight: 600;
}
.pack-price {
  margin-left: 3px;
  display: inline-block;
  background: #daedff;
  border-radius: 24px;
  padding: 4px 13px 6px 12px;
  color: $color-blue;
  font-weight: 600;
  //text-decoration: underline;
}
.pack-price:hover {
  cursor: pointer;
  //background: lighten(#daedff, 2%);
  text-decoration: underline;
}

.pack-uses {
  margin-left: 0px;
  display: inline-block;
  background: #daedff;
  border-radius: 24px;
  padding: 4px 12px 6px 12px;
  color: $color-blue;
  font-weight: 600;
  //text-decoration: underline;
}

.assistant-about {
  padding: 18px 29px 18px 23px;
  font-size: 13.5pt;
  line-height: 1.35em;
}
.assistant-must-buy {
  padding: 0px 29px 18px 23px;
  font-size: 12.5pt;
  line-height: 1.35em;
  color: #c17a00;
  font-weight: 600;
}

.assistant-buy {
  //background: lighten(#e8f4fd, 2%);
  margin-top: 12px;
  border-radius: 0 0 8px 8px;
  border-top: 1px solid #e3e3e3;
  padding: 14px 0 14px 20px;
  font-size: 13.5pt;
  font-weight: 600;
  color: darken(#128ff2, 10%);
}
.buy-option {
  display: flex;
}

.special-price {
  color: darken(#c36367, 0%);
  font-size: 12.5pt;
  font-weight: 600;
}

.assistant-more {
  padding: 0 30px 6px 36px;
}
.upgrade-more-list {
  padding: 0px 20px 0 30px;
  .upgrade-more-item {
    padding: 5px 0px;
    color: #111;
    font-size: 12.5pt;
    font-weight: 400;
  }
}
.assistant-more-end {
  padding-bottom: 20px;
}

.learn-more:hover {
  text-decoration: underline;
  cursor: pointer;
}

.assistant-suggested-review {
  background: #f3f3f3;
  margin: 0px 20px 20px 20px;
  padding: 20px;
  border-radius: 12px;
}
.assistant-suggested-review-summary {
  display: flex;
  padding-bottom: 0.5em;
  font-size: 14pt;
  font-weight: 700;

  .assistant-suggested-review-summary-stars {
    height: 14px;
    margin: 6px 8px 0 0;
  }
}
.assistant-suggested-review-content {
  font-size: 13pt;
  font-weight: 500;
  line-height: 1.4em;
}

.clearfix {
  clear: both;
}

// Payment crossport

.promote-option {
  margin-bottom: 20px;
  padding: 16px 40px 16px 28px;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  border-radius: 8px;
  border-top: 4px solid $color-blue;
  font-family: $font-family;
}
.promote-option-title {
  font-size: 19pt;
  font-weight: 500;
  color: $color-blue;
}
.promote-option-more {
  font-size: 13.5pt;
  font-weight: 600;
  color: darken($color-blue, 0%);
}
.promote-option-description {
  padding-top: 0.5em;
  font-size: 12.5pt;
  font-weight: 500;
  line-height: 1.4em;
}

.promote-option-snaps {
  border-top: 4px solid $color-snaps;
  .promote-option-title {
    color: $color-snaps;
  }
}

.payment-line {
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
  margin: 16px 0 16px 0;
  padding: 12px 0 16px 0;
  font-size: 12pt;
  font-weight: 500;
  color: #111;
  font-size: 12pt;
}
</style>